import { Box, Flex } from "@chakra-ui/react";
import { useScrollDirection } from "hooks";
import { setSubHeaderStyles } from "../Header.utils";
import { ActionButton } from "../HeaderButtons/ActionButton";
import { HeaderFlagBox } from "../HeaderFlagBox";
import { HeaderLogo } from "../HeaderLogo";
import type { HeaderDesktopProps } from "../types";
import { HeaderLinks } from "./HeaderLinks";

export const HeaderDesktop = ({
  headerLinks,
  headerActionButton,
  pageLanguage,
  headerLogo,
  hideFlagBox,
}: HeaderDesktopProps) => {
  const { scrollDirection } = useScrollDirection();
  return (
    <>
      <Flex>
        <HeaderLogo language={pageLanguage} headerLogo={headerLogo} />
        {!hideFlagBox && <HeaderFlagBox testId="header-flag-box-language-switcher" />}
        <ActionButton activeButtonOption={headerActionButton} />
      </Flex>
      <Box sx={setSubHeaderStyles(scrollDirection)}>
        <HeaderLinks headerLinks={headerLinks} />
      </Box>
    </>
  );
};
